<template>
    <el-tabs v-model="activeTab" stretch style="width: 100%">
        <el-tab-pane :label="$t('login.PasswordLogin')" name="password">
            <el-form
                :model="loginFormByPassword"
                :rules="loginFormByPasswordRules"
                ref="passwordForm"
            >
                <el-form-item prop="username">
                    <el-input
                        v-model="loginFormByPassword.username"
                        :placeholder="$t('login.PleaseEnterAccount')"
                        size="large"
                    >
                        <img
                            src="~@/assets/img/person.png"
                            alt=""
                            slot="prefix"
                            class="input-icon"
                        />
                    </el-input>
                </el-form-item>
                <el-form-item prop="password">
                    <el-input
                        @keyup.enter.native="handleLogin"
                        v-model="loginFormByPassword.password"
                        :placeholder="$t('login.PleaseEnterPassword')"
                        size="large"
                        class="input-margin"
                        type="password"
                    >
                        <img
                            src="~@/assets/img/psandreps.png"
                            alt=""
                            slot="prefix"
                            class="input-icon"
                        />
                    </el-input>
                </el-form-item>
            </el-form>
        </el-tab-pane>
        <el-tab-pane :label="$t('login.VCodeLogin')" name="code">
            <el-form
                :model="loginFormByCode"
                :rules="loginFormByCodeRules"
                ref="codeForm"
            >
                <el-form-item prop="account">
                    <el-input
                        v-model="loginFormByCode.account"
                        :placeholder="$t('login.PleaseEnterMobileEmail')"
                        size="large"
                    >
                        <img
                            src="~@/assets/img/phoneicon.png"
                            alt=""
                            slot="prefix"
                            class="input-icon"
                        />
                    </el-input>
                </el-form-item>
                <el-form-item prop="code">
                    <el-input
                        @keyup.enter.native="handleLogin"
                        v-model="loginFormByCode.code"
                        :placeholder="$t('login.PleaseEnterVCode')"
                        size="large"
                        class="input-margin input-code"
                    >
                        <img
                            src="~@/assets/img/psicon.png"
                            alt=""
                            slot="prefix"
                            class="input-icon"
                        />
                        <div
                            slot="suffix"
                            :class="!isGettingCode ? 'get-code' : 'in-get-code'"
                            @click="!isGettingCode && handleGetCode()"
                        >
                            {{ codeText }}
                        </div>
                    </el-input>
                </el-form-item>
            </el-form>
        </el-tab-pane>
        <el-checkbox class="input-margin" v-model="isRemember">{{
                $t('login.RememberMe')
            }}
        </el-checkbox>
        <div>
            <el-checkbox v-model="isAgree">{{
                    $t('login.ContinueAgree')
                }}
            </el-checkbox>
            <a
                class="font-color"
                style="margin-left: 5px; font-size: 12px"
                @click.prevent="$emit('handleShowPrivacy')"
                href="#"
            >{{ $t('common.PrivacyPolicy') }}</a
            >
        </div>
        <div class="register-btn">
            {{ $t('login.DontHaveAccount') }}
            <a @click.prevent="$emit('handleRegister')" href="#">{{
                    $t('login.RegisterNow')
                }}</a>
        </div>
        <button class="login-btn" @click="handleLogin">
            {{ $t('login.SignIn') }}
        </button>
    </el-tabs>
</template>

<script>
import {
    sentEmailOrPhoneCode,
    userLoginByCode,
    userLoginByPassword,
} from '@/api/login'
import { storageSet, throttle } from '@/utils'
import { codeLoginError, passwordLoginError } from '@/utils/errorMessage'
import { getMyUserInfo } from '@/api/user'
import { storageKey } from '@/utils/config'
import { Message } from 'element-ui'

export default {
    name: 'LoginForm',
    data () {
        return {
            activeTab: 'password',
            loginCodeType: '',
            loginFormByPassword: {
                username: localStorage.LoginUsername || '',
                password: localStorage.LoginPassword || '',
            },
            loginFormByPasswordRules: {
                username: [
                    {
                        required: true,
                        message: this.$t('login.PleaseEnterAccountTip'),
                        trigger: 'change',
                    },
                ],
                password: [
                    {
                        required: true,
                        message: this.$t('login.PleaseEnterPasswordTip'),
                        trigger: 'change',
                    },
                ],
            },
            loginFormByCode: {
                account: '',
                code: '',
            },
            loginFormByCodeRules: {
                account: [
                    {
                        required: true,
                        message: this.$t('login.PleaseEnterMobileEmailTip'),
                        trigger: 'change',
                    },
                ],
                code: [
                    {
                        required: true,
                        message: this.$t('login.PleaseEnterVCode'),
                        trigger: 'change',
                    },
                ],
            },
            codeText: this.$t('common.GetCode'),
            isGettingCode: false,
            isRemember: Boolean(localStorage.LoginRemember) || false,
            isAgree: true,
        }
    },
    methods: {
        handleGetCode: throttle(function () {
            this.$refs['codeForm'].validateField('account', async (error) => {
                if (!error) {
                    const { account } = this.loginFormByCode

                    let codeTime = 60
                    const timer = setInterval(() => {
                        if (codeTime === 0) {
                            clearTimeout(timer)
                            this.codeText = this.$t('common.GetCode')
                            this.isGettingCode = false
                        } else {
                            codeTime--
                            this.codeText = `${this.$t(
                                'common.Resend'
                            )} (${codeTime}s ${this.$t('common.After')})`
                        }
                    }, 1000)

                    this.isGettingCode = true
                    const { success, errorMessage } =
                        await sentEmailOrPhoneCode(account)
                    if (success) {
                        this.$message.success('验证码已发送')
                    } else {
                        this.$message.error(
                            codeLoginError[errorMessage] || '发送失败，未知错误'
                        )
                    }
                }
            })
        }, 1000),
        async login(data) {
            await this.$store.commit('setUserId', data.loginId)
            await this.$store.commit('setToken', data.tokenValue)

            const res = await getMyUserInfo()
            if (!res.userId) {
                this.$emit('loginFail')
                return
            }
            await this.$store.commit('setUserPhone', res.mobile)
            await this.$store.commit('setUserAccount', res.username)
            await this.$store.commit('setUserName', `${res.fname}${res.lname}`)
            storageSet(storageKey.user, res)
            if (!res.tenantInfoList.length) {
                Message.error('暂无租户')
                this.$emit('loginFail')
                return;
            }
            // 检查完毕 显示选择公司
            this.$emit('showChooseCompany', res.tenantInfoList)
        },
        loginByPassword () {
            this.$refs['passwordForm'].validate(async (valid) => {
                if (valid) {
                    if (!this.isAgree)
                        return this.$message.error('请同意《签泰隐私协议》')
                    this.$emit('handleLogin')
                    const { username, password } = this.loginFormByPassword
                    try {
                        const data = await userLoginByPassword(username, password)
                        // 是否需要保存信息
                        this.checkRememberUser()
                        this.login(data);
                    } catch (e) {
                        this.$emit('loginFail')
                    }
                }
            })
        },
        submitCode () {
            this.$refs['codeForm'].validate((valid) => {
                if (valid) {
                    this.$emit('handleLogin')
                    const { account, code } = this.loginFormByCode
                    if (!this.isAgree)
                        return this.$message.error('请同意《签泰隐私协议》')
                    this.loginByCode(account, code)
                }
            })
        },
        async loginByCode (account, code) {
            const { success, data } = await userLoginByCode(account, code)
            if (success) {
                this.login(data);
            } else {
                this.$emit('loginFail')
            }
        },
        // 登录节流限制 防止多次点击提交无用请求
        handleLogin: throttle(function () {
            this.activeTab === 'password'
                ? this.loginByPassword()
                : this.submitCode()
        }, 1000),
        checkRememberUser () {
            if (this.isRemember) {
                localStorage.LoginUsername = this.loginFormByPassword.username
                localStorage.LoginPassword = this.loginFormByPassword.password
                localStorage.LoginRemember = this.isRemember
            } else {
                localStorage.removeItem('LoginUsername')
                localStorage.removeItem('LoginPassword')
                localStorage.removeItem('LoginRemember')
            }
        },
        checkRightPhone (phone) {
            return /^1[123456789]\d{9}$/.test(phone)
        },
    },
}
</script>

<style scoped lang="scss">
@import "../style/LoginForm";
</style>
